import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/empty.png'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-inner page-left" }
const _hoisted_3 = { class: "upload-inner" }
const _hoisted_4 = { style: {"margin":"20px 0"} }
const _hoisted_5 = { class: "page-inner page-right" }
const _hoisted_6 = {
  key: 0,
  class: "page-inner-box parseBox"
}
const _hoisted_7 = {
  key: 0,
  class: ""
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: ""
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 2,
  class: ""
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 3,
  class: ""
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 2,
  class: "page-inner-box empty"
}

import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { compModelAnalysisStreamingV1, saveSreamResult, checkAiCall } from "@/api/composition.js"
import { uploadImg, delImgApi } from "@/api/common.js"
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
import { useStore } from "vuex"

export default /*@__PURE__*/_defineComponent({
  __name: 'modelEssay',
  setup(__props) {

const store = useStore();
const correctText = ref('')
const fileList = ref([])
const showPreview = ref(false)
const previewIndex = ref(0)
const previewFileArr = ref([])
let fileArr = []
let controller = null
let aiMessage = ref('')
let resultInfo = ref({})
let timeFlag = 0
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const aiStart = ref(false)
const popupShow = ref(false)
function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function modelEssayClick() {
    if (!correctText.value && !fileList.value.length) {
        return ElMessage.warning('请填写作文文本或拍摄作文');
    }
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })

}
function getAi() {
    const params = {
        grade: sessionStorage.getItem("grade"),
        term: sessionStorage.getItem("term"),
        text: correctText.value || '',
        fileIds: fileArr.map(item => {
            return item.fileId
        }).join(','),
    }
    aiStart.value = true
    popupShow.value = true
    fetchRequest({
        url: compModelAnalysisStreamingV1,
        aiParam: params,
        timeFlag: new Date().getTime()
    })
    // compModelAnalysisStreaming(params).then(res => {
    //     fetchRequest(res.data)
    // }).catch(() => {
    //     aiStart.value = false
    //     popupShow.value = false
    // })
}

async function fetchRequest(params) {
    if (timeFlag == params.timeFlag) return;
    timeFlag = params.timeFlag;
    controller = new AbortController()
    aiMessage.value = ''
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    const { signal } = controller;
    const response = await fetch(params.url, {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem("token"),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const lines = chunkText.split('\n')
            let isMessage = true;
            lines.forEach(line => {
                if (line.indexOf('Done') > -1) {
                    isMessage = false;
                    aiStart.value = false
                }
                if (line.indexOf('Error') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    return ElMessage.warning('AI调用失败，请稍后再试！');
                }
                if (line.indexOf('"500"') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    let errorMsg = JSON.parse(line).msg;
                    return ElMessage.warning(errorMsg || 'AI调用失败，请稍后再试！');
                }
                if (isMessage && line.indexOf('content') > -1) {
                    let jsonString = '';
                    if (line.startsWith('data:')) {
                        jsonString = line.substring(5).trim();
                    } else {
                        jsonString = line
                    }

                    if (jsonString) {
                        try {
                            const jsonData = JSON.parse(jsonString)
                            const content = (jsonData ?.content || '');
                            if (content) {
                                str += content
                                const matches = content.match(regex) || [];
                                let resultArr = matches.filter(match => match !== '');
                                resultArr.forEach(info => {
                                    if (romanNumerals.includes(info)) {
                                        if (info in resultNum) {
                                            resultNum[info] = resultNum[info] + 1;
                                            resultInfo.value[info].push('');
                                        } else {
                                            resultNum[info] = 1;
                                            resultInfo.value[info] = [''];
                                        }
                                        currentKey = info;
                                    } else if (currentKey in resultInfo.value) {
                                        if (resultNum[currentKey] == 1) {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                                        } else {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                                        }

                                    }
                                })
                                console.log(resultInfo.value)
                                aiMessage.value = str
                            }
                        } catch (error) {
                            console.log(error)
                            aiStart.value = false
                            return ElMessage.warning('AI调用失败，请稍后再试！');
                        }
                    }
                }
            })
        } else {
            aiStart.value = false;
        }
    }
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    const loading = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.5)',
    })
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    }).finally(() => {
        loading.close()
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        // delImgApi(file.fileId).then(res => {
        ElMessage.success('删除成功')
        fileArr.splice(index, 1)
        previewFileArr.value.splice(index, 1)
        // })
    }
}

onBeforeUnmount(() => {
    controller && controller.abort()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Camera = _resolveComponent("Camera")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-box-title title1" }, "范文解析", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_el_row, {
          gutter: 10,
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  maxlength: "5000",
                  modelValue: correctText.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((correctText).value = $event)),
                  type: "textarea",
                  rows: 6,
                  placeholder: "请输入作文文本，文本拍照二选一即可"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 10,
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-box",
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
                  action: "#",
                  max: 5,
                  "list-type": "picture-card",
                  "http-request": httpRequest,
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_icon, { size: "24" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Camera)
                          ]),
                          _: 1
                        })
                      ]),
                      _cache[3] || (_cache[3] = _createElementVNode("div", null, "题目拍摄", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "correct-tip" }, [
          _createElementVNode("span", { class: "activeColor" }, "*提示："),
          _createElementVNode("span", null, "一次拍一页，可多次拍摄，最多可拍摄5页")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          disabled: aiStart.value,
          style: {"width":"100%"},
          color: "#ef8b25",
          class: "footer-btn1",
          onClick: modelEssayClick
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("AI作文解析")
          ])),
          _: 1,
          __: [5]
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "page-box-title2 title1" }, "范文解析结果", -1)),
      (Object.keys(_unref(resultInfo)).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "correctTitle" }, "三步：放 → 悟 → 收", -1)),
            (_unref(resultInfo).Ⅰ && _unref(resultInfo).Ⅰ.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "correctTitle3" }, "放（释放想象，积累素材）", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "correctTitle5" }, "在“放”的阶段，作者要尽可能多地打开思维，积累丰富的素材。这是作文的起点，决定了接下来的内容的广度和深度。", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅰ, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: 'f'+index
                    }, [
                      _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_8)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅱ && _unref(resultInfo).Ⅱ.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "correctTitle3" }, "悟（深化思考，提炼规律）", -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "correctTitle5" }, " 在“悟”的阶段，是把收集到的素材进行升华，形成深刻的思考和认识。这里作者通过思考和推理，让素材不仅仅是表面上的描述，而是带有思想的深度。", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅱ, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: 'w'+index
                    }, [
                      _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_10)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅲ && _unref(resultInfo).Ⅲ.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "correctTitle3" }, "收（整合资源，形成结构）", -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "correctTitle5" }, " 在“收”的阶段，是将之前积累的素材与观点整合起来，形成文章的整体结构。在这一阶段，作者将所有的感受、观察与思考有条理地组织成文章的框架，确保文章逻辑清晰，层次分明。 ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅲ, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: 's'+index
                    }, [
                      _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_12)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅳ && _unref(resultInfo).Ⅳ.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "correctTitle3" }, "总结", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅳ, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: 'z'+index
                    }, [
                      _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_14)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!Object.keys(_unref(resultInfo)).length && _unref(aiMessage) && _unref(aiMessage)!='{}')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            innerHTML: _unref(aiMessage),
            class: "page-inner-box"
          }, null, 8, _hoisted_15))
        : _createCommentVNode("", true),
      (!Object.keys(_unref(resultInfo)).length && !_unref(aiMessage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[15] || (_cache[15] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("div", null, "结果将在此处展示！", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    (showPreview.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": previewFileArr.value,
          "show-progress": "",
          "initial-index": previewIndex.value,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showPreview.value = false))
        }, null, 8, ["url-list", "initial-index"]))
      : _createCommentVNode("", true),
    (popupShow.value)
      ? (_openBlock(), _createBlock(AIpopup, {
          key: 1,
          cancelShow: false,
          popupShow: popupShow.value,
          onCancel: aiCancel
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true)
  ]))
}
}

})